/* eslint-disable no-unused-expressions */
/* eslint-disable no-case-declarations */
import Scene from 'scenejs';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

const ElementAnimationMixin = {
  data() {
    return {
      scene:              new Scene(),
      scenes:             new Scene(),
      multipleScenesJson: {},
      animations:         {},
      selector:           null,
      selectedObject:     null,
      typingSelector:     '',
      typingInProgress:   false,
      originalTextHTML:   '',
      tempHtml:           null,
      tempSelector:       '',
    };
  },
  mounted() {
    EventBus.$on(ApplicationEventTypes.AnimationEvent.STOP_OBJECT_ANIMATION, this.stopScene);
    EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.OBJECT_DUPLICATE, this.sceneEnded);
  },
  beforeDestroy() {
    EventBus.$off(ApplicationEventTypes.AnimationEvent.STOP_OBJECT_ANIMATION, this.stopScene);
    EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.OBJECT_DUPLICATE, this.sceneEnded);
  },
  methods: {
    animateElement({
      speed, style, onEnter = true, onExit = false, duration, distance,
    }) {
      console.log('distance');
      console.log(distance);
      console.log(style);
      this.scene.end();
      this.scene.setTime(0);
      const startTime        = 0.0;
      let transitionDuration = 0.0;
      transitionDuration     = this.getTransitionTime(speed, duration);
      if (this.typingSelector) {
        document.querySelector(this.typingSelector).innerHTML = this.originalTextHTML;
        this.typingSelector                                   = '';
      }
      const { activeObject } = this;
      this.selectedObject    = activeObject;
      const index            = activeObject.elementIndex;
      let selector           = `.canvas-section .canvas-non-play-all div[data-elementindex='${index}']`;
      let objectOpacity      = activeObject.effects ? activeObject.effects.transparency.value / 100 : 1;
      if (activeObject.type === 'shape') { objectOpacity = activeObject.Alpha / 100; }

      this.tempSelector               = selector;
      let numOfCharacter              = 0;
      let exitDistance                = 0;
      let animationDurationPercentage = null;
      this.tempHtml                   = document.querySelector(selector).getAttribute('style');
      distance                        = parseFloat(distance) + 20;
      let animation                   = {};
      switch (style) {
        case 'panleft':
          if (onEnter && !onExit) {
            animation[startTime] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
            animation[startTime + 0.00001] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: `${distance}%`,
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
          } else if (!onEnter && onExit) {
            animation[startTime] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
            animation[transitionDuration] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: `-${distance}%`,
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          } else if (onEnter && onExit) {
            animation[startTime] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
            animation[startTime + 0.00001] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: `${distance}%`,
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration + transitionDuration] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: `-${distance}%`,
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          }
          break;
        case 'panright':
          if (onEnter && !onExit) {
            animation[startTime] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
            animation[startTime + 0.00001] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: `-${distance}%`,
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
          } else if (!onEnter && onExit) {
            animation[startTime] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
            animation[transitionDuration] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: `${distance}%`,
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          } else if (onEnter && onExit) {
            animation[startTime] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
            animation[startTime + 0.00001] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: `-${distance}%`,
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration + transitionDuration] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateX: `${distance}%`,
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          }
          break;
        case 'pantop':
          if (onEnter && !onExit) {
            animation[startTime] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
            animation[startTime + 0.00001] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: `${distance}%`,
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
          } else if (!onEnter && onExit) {
            animation[startTime] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
            animation[transitionDuration] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: `-${distance}%`,
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          } else if (onEnter && onExit) {
            animation[startTime] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
            animation[startTime + 0.00001] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: `${distance}%`,
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration + transitionDuration] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: `-${distance}%`,
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          }
          break;
        case 'panbottom':
          if (onEnter && !onExit) {
            animation[startTime] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
            animation[startTime + 0.00001] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: `-${distance}%`,
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
          } else if (!onEnter && onExit) {
            animation[startTime] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
            animation[transitionDuration] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: `${distance}%`,
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          } else if (onEnter && onExit) {
            animation[startTime] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
            animation[startTime + 0.00001] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: `-${distance}%`,
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration + transitionDuration] = {
              transform: {
                scale:      activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : undefined,
                translateY: `${distance}%`,
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          }
          break;
        case 'fade':
          if (onEnter && !onExit) {
            animation[startTime] = {
              opacity: objectOpacity,
            },
            animation[startTime + 0.00001] = {
              opacity: 0,
            },
            animation[transitionDuration] = {
              opacity: objectOpacity,
            };
          } else if (!onEnter && onExit) {
            animation[startTime] = {
              opacity: objectOpacity,
            },
            animation[startTime + 0.1] = {
              opacity: objectOpacity,
            },
            animation[transitionDuration] = {
              opacity: 0,
            },
            animation[transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          } else if (onEnter && onExit) {
            animation[startTime] = {
              opacity: objectOpacity,
            },
            animation[startTime + 0.00001] = {
              opacity: 0,
            },
            animation[transitionDuration] = {
              opacity: objectOpacity,
            },
            animation[transitionDuration + transitionDuration] = {
              opacity: 0,
            },
            animation[transitionDuration + transitionDuration + 0.0004] = {
              opacity: objectOpacity,
            };
          }
          break;
        case 'zoomin':
          if (onEnter && !onExit) {
            animation[startTime] = {
              transformOrigin: 'center center',
              transform:       {
                scale:  activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
            animation[startTime + 0.0001] = {
              transform: {
                scale:  activeObject.type === 'text' ? `${70 / 100 * activeObject.scaleX},${70 / 100 * activeObject.scaleY}` : '70%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            },
            animation[transitionDuration] = {
              transform: {
                scale:  activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
          } else if (!onEnter && onExit) {
            animation[startTime] = {
              transformOrigin: 'center center',
              transform:       {
                scale:  activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'none',
            },
            animation[startTime + 0.00001] = {
              transform: {
                scale:  activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration] = {
              transform: {
                scale: activeObject.type === 'text' ? `${130 / 100 * activeObject.scaleX},${130 / 100 * activeObject.scaleY}` : '130%',
              },
              opacity: 0,
            };
          } else if (onEnter && onExit) {
            animation[startTime] = {
              transformOrigin: 'center center',
              transform:       {
                scale:  activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[startTime + 0.0001] = {
              transform: {
                scale:  activeObject.type === 'text' ? `${70 / 100 * activeObject.scaleX},${70 / 100 * activeObject.scaleY}` : '70%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity:    0,
              transition: 'none',
            },
            animation[transitionDuration] = {
              transform: {
                scale:  activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
            },
            animation[transitionDuration + 0.0001] = {
              transform: {
                scale:  activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            },
            animation[transitionDuration + transitionDuration] = {
              transform: {
                scale:  activeObject.type === 'text' ? `${130 / 100 * activeObject.scaleX},${130 / 100 * activeObject.scaleY}` : '130%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            },
            animation[transitionDuration + transitionDuration + 0.0001] = {
              transform: {
                scale:  activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
          }
          break;
        case 'zoomout':
          if (onEnter && !onExit) {
            animation[startTime] = {
              transformOrigin: 'center center',
              transform:       {
                scale: '100%',
              },
            },
            animation[startTime + 0.00001] = {
              transform: {
                scale: '100%',
              },
            },
            animation[transitionDuration] = {
              transform: {
                scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-0.70' : '0.70'},${activeObject.IsVFlipped === true ? '-0.70' : '0.70'}` : '70%',
              },
            };
          } else if (!onEnter && onExit) {
            animation[startTime] = {
              transformOrigin: 'center center',
              transform:       {
                scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
              },
            },
            animation[startTime + 0.1] = {
              transform: {
                scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
              },
            },
            animation[transitionDuration] = {
              transform: {
                scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-130%' : '130%'},${activeObject.IsVFlipped === true ? '-130%' : '130%'}` : '130%',
              },
            };
          } else if (onEnter && onExit) {
            animation[startTime] = {
              transformOrigin: 'center center',
              transform:       {
                scale: '100%',
              },
            },
            animation[startTime + 0.00001] = {
              transform: {
                scale: '100%',
              },
            },
            animation[transitionDuration] = {
              transform: {
                scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-0.70' : '0.70'},${activeObject.IsVFlipped === true ? '-0.70' : '0.70'}` : '70%',
              },
            },
            animation[transitionDuration + 0.0001] = {
              transform: {
                scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
              },
            },
            animation[transitionDuration + 1] = {
              transform: {
                scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
              },
            },
            animation[transitionDuration + transitionDuration] = {
              transform: {
                scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-130%' : '130%'},${activeObject.IsVFlipped === true ? '-130%' : '130%'}` : '130%',
              },
            },
            animation[transitionDuration + transitionDuration + 0.0001] = {
              transform: {
                scale: (activeObject.ImageType == 'Image' || activeObject.type == 'video' || activeObject.ImageType == 'SVGImage') ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
              },
            };
          }
          break;
        case 'burst':
          selector             += '';
          this.typingSelector   = selector;
          let originalHTML      = this.originalTextHTML = document.querySelector(selector).innerHTML;
          this.typingInProgress = true;
          let newHTML           = '';
          let tagStarted        = false;
          let ampersendStarted  = false;

          const el     = document.querySelector(selector);
          el.innerHTML = el.innerHTML.replace(/>\s+</g, '><');
          el.innerHTML = el.innerHTML.replace(/(?<!(<\/?[^>]*|&[^;]*))([^\s<]+)/g, '$1<span style="display:inline-block">$2</span>');

          this.spanEachCharacter(el);
          numOfCharacter              = [document.querySelectorAll(`${selector} .animationItem`)][0].length;
          exitDistance                = numOfCharacter / 10;
          animationDurationPercentage = this.getTypwriterSpeed(speed, duration);
          let exitDelay               = 2;
          if (numOfCharacter > 300) {
            exitDelay = 10;
          }
          if (numOfCharacter > 600) {
            exitDelay = 30;
          }
          animation = {
            0: {
              opacity: onEnter ? 0 : 1,
              display: 'inline-flex',
            },
            0.00001: {
              opacity:   onEnter ? 0 : 1,
              transform: onExit && !onEnter ? 'scale(1)' : 'scale(0.1)',
            },
            0.45: {
              opacity:   1,
              transform: onEnter ? 'scale(1.2)' : 'scale(01)',
            },
            0.48: {
              opacity:   1,
              transform: 'scale(1.0)',
            },
            [animationDurationPercentage]: {
              opacity: 1,
            },
            [animationDurationPercentage + exitDistance]: {
              opacity: 1,
            },
            [animationDurationPercentage + exitDistance + exitDelay]: {
              opacity: onExit ? 0 : 1,
            },
          };
          break;
        case 'typewriter':
          // selector += '';
          this.typingSelector   = selector;
          originalHTML          = this.originalTextHTML = document.querySelector(selector).innerHTML;
          this.typingInProgress = true;
          newHTML               = '';
          tagStarted            = false;
          ampersendStarted      = false;
          for (let i = 0; i < originalHTML.length; i++) {
            if (originalHTML[i] === '<' && !ampersendStarted) {
              tagStarted = true;
            }
            if (originalHTML[i] === '&' && !tagStarted) {
              ampersendStarted = true;
              newHTML          = `${newHTML}<span class="animationItem" >`;
            }
            if (!tagStarted && !ampersendStarted) {
              newHTML = `${newHTML}<span class="animationItem" >${originalHTML[i]}</span>`;
            } else {
              newHTML += originalHTML[i];
            }
            if (originalHTML[i] === '>' && tagStarted) {
              tagStarted = false;
            }
            if (originalHTML[i] === ';' && ampersendStarted) {
              ampersendStarted = false;
              newHTML          = `${newHTML}</span>`;
            }
          }
          document.querySelector(selector).innerHTML = newHTML;
          numOfCharacter                             = [document.querySelectorAll(`${selector} .animationItem`)][0].length;
          exitDistance                               = numOfCharacter / 10;
          animationDurationPercentage                = this.getTypwriterSpeed(speed, duration);
          animation                                  = {
            0: {
              opacity: onEnter ? 0 : 1,
            },
            0.24: {
              opacity: onEnter ? 0 : 1,
            },
            0.25: {
              opacity: 1,
            },
            [animationDurationPercentage]: {
              opacity: 1,
            },
            [animationDurationPercentage + exitDistance]: {
              opacity: 1,
            },
            [animationDurationPercentage + exitDistance + 0.001]: {
              opacity: onExit ? 0 : 1,
            },
          };
          break;
        case 'stomp':
          if (onEnter && !onExit) {
            animation[startTime] = {
              transformOrigin: 'center center',
              transform:       {
                scale:  activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              transition: 'none',
            },
            animation[startTime + 0.00001] = {
              transform: {
                scale:  activeObject.type === 'text' ? `${1000 / 100 * activeObject.scaleX},${1000 / 100 * activeObject.scaleY}` : '1000%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
            },
            animation[transitionDuration] = {
              transform: {
                scale:  activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
            };
          } else if (!onEnter && onExit) {
            animation[startTime]          = {
              opacity:    objectOpacity,
              transition: 'none',
            };
            animation[startTime + 0.0001] = {
              opacity: 0,
            };
            animation[transitionDuration] = {
              opacity: objectOpacity,
            };
          } else if (onEnter && onExit) {
            animation[startTime]                                        = {
              transformOrigin: 'center center',
              transform:       {
                scale:  activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              transition: 'none',
            };
            animation[startTime + 0.00001]                              = {
              transform: {
                scale:  activeObject.type === 'text' ? `${1000 / 100 * activeObject.scaleX},${1000 / 100 * activeObject.scaleY}` : '1000%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
            };
            animation[transitionDuration]                               = {
              transform: {
                scale:  activeObject.type === 'text' ? `${activeObject.scaleX},${activeObject.scaleY}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
            animation[transitionDuration + transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          }
          break;
        case 'spreadout':
          animation = {
            0: {
              letterSpacing: 'inherit',
              width:         '100% !important',
              transform:     {
                translateX: '0%',
              },
            },
            0.00001: {
              width:         '100%  !important',
              letterSpacing: '0px',
              transform:     {
                translateX: '0%',
              },
            },
            5: {
              width:         '200% !important',
              letterSpacing: '5px',
              transform:     {
                translateX: '-25%',
              },
            },
          };
          break;
        case 'spreadin':
          animation = {
            0: {
              letterSpacing: 'inherit',
              width:         '100% !important',
              transform:     {
                translateX: '0%',
              },
            },
            0.00001: {
              width:         '200% !important',
              letterSpacing: '5px',
              transform:     {
                translateX: '-25%',
              },
            },
            4.9999: {
              width:         '100%  !important',
              letterSpacing: '0px',
              transform:     {
                translateX: '0%',
              },
            },
            5: {
              width:         '100%  !important',
              letterSpacing: 'inherit',
              transform:     {
                translateX: '0%',
              },
            },
          };
          break;
        case 'photoZomEnterIn':
          console.log('Animating photo zoom');
          selector += ' img';
          if (onEnter && !onExit) {
            animation[startTime]          = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity:    1,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.0001] = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration] = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-130%' : '130%'},${activeObject.IsVFlipped === true ? '-130%' : '130%'}` : '130%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 1,
            };
          } else if (!onEnter && onExit) {
            animation[startTime]                   = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity:    1,
              transition: 'all 100ms linear',
            };
            animation[transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + 0.0001] = {
              opacity: 1,
            };
          } else if (onEnter && onExit) {
            animation[startTime]                                        = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity:    1,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.000001]                             = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration]                               = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-130%' : '130%'},${activeObject.IsVFlipped === true ? '-130%' : '130%'}` : '130%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 1,
            };
            animation[transitionDuration + 0.00001]                     = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 1,
            };
            animation[transitionDuration + transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: 1,
            };
          }
          break;
        case 'photoZomEnterOut':
          selector += ' img';
          if (onEnter && !onExit) {
            animation[startTime]          = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.0001] = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration] = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 1,
            };
          } else if (!onEnter && onExit) {
            animation[startTime]                   = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity:    1,
              transition: 'all 100ms linear',
            };
            animation[transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + 0.0001] = {
              opacity: 1,
            };
          } else if (onEnter && onExit) {
            animation[startTime]                                        = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity:    1,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.000001]                             = {
              transform: {
                scale:  activeObject.ImageType === 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration]                               = {
              transform: {
                scale:  activeObject.ImageType === 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 1,
            };
            animation[transitionDuration + 0.00001]                     = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 1,
            };
            animation[transitionDuration + transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: 1,
            };
          }
          break;
        case 'photoRiseTop':
          selector += ' img';
          if (onEnter && !onExit) {
            animation[startTime]          = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.0001] = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration] = {
              transform: {
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '5%' : '-5%'}` : '-5%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
          } else if (!onEnter && onExit) {
            animation[startTime]                   = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          } else if (onEnter && onExit) {
            animation[startTime]                                        = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.000001]                             = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration]                               = {
              transform: {
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '5%' : '-5%'}` : '-5%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
            animation[transitionDuration + 0.00001]                     = {
              transform: {
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
            animation[transitionDuration + transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          }
          break;
        case 'photoRiseBottom':
          selector += ' img';
          if (onEnter && !onExit) {
            animation[startTime]          = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.0001] = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration] = {
              transform: {
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '-5%' : '5%'}` : '5%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
          } else if (!onEnter && onExit) {
            animation[startTime]                   = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          } else if (onEnter && onExit) {
            animation[startTime]                                        = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.000001]                             = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration]                               = {
              transform: {
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '-5%' : '5%'}` : '5%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
            animation[transitionDuration + 0.00001]                     = {
              transform: {
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
            animation[transitionDuration + transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          }
          break;
        case 'photoRiseLeft':
          selector += ' img';
          if (onEnter && !onExit) {
            animation[startTime]          = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.0001] = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration] = {
              transform: {
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '5%' : '-5%'}` : '-5%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
          } else if (!onEnter && onExit) {
            animation[startTime]                   = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          } else if (onEnter && onExit) {
            animation[startTime]                                        = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.000001]                             = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration]                               = {
              transform: {
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '5%' : '-5%'}` : '-5%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
            animation[transitionDuration + 0.00001]                     = {
              transform: {
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
            animation[transitionDuration + transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          }
          break;
        case 'photoRiseRight':
          selector += ' img';
          if (onEnter && !onExit) {
            animation[startTime]          = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.0001] = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration] = {
              transform: {
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-5%' : '5%'}` : '5%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
          } else if (!onEnter && onExit) {
            animation[startTime]                   = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateY: activeObject.ImageType == 'Image' ? `${activeObject.IsVFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          } else if (onEnter && onExit) {
            animation[startTime]                                        = {
              transform: {
                scale:      activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-100%' : '100%'},${activeObject.IsVFlipped === true ? '-100%' : '100%'}` : '100%',
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity:    objectOpacity,
              transition: 'all 100ms linear',
            };
            animation[startTime + 0.000001]                             = {
              transform: {
                scale:  activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-120%' : '120%'},${activeObject.IsVFlipped === true ? '-120%' : '120%'}` : '120%',
                rotate: `${activeObject.RotateDegree}deg`,
              },
              opacity: 0,
            };
            animation[transitionDuration]                               = {
              transform: {
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '-5%' : '5%'}` : '5%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
            animation[transitionDuration + 0.00001]                     = {
              transform: {
                translateX: activeObject.ImageType == 'Image' ? `${activeObject.IsHFlipped === true ? '0%' : '0%'}` : '0%',
                rotate:     `${activeObject.RotateDegree}deg`,
              },
              opacity: objectOpacity,
            };
            animation[transitionDuration + transitionDuration]          = {
              opacity: 0,
            };
            animation[transitionDuration + transitionDuration + 0.0001] = {
              opacity: objectOpacity,
            };
          }
          break;
        default:
          return;
      }

      if (style == 'burst' || style == 'typewriter') {
        this.scene = new Scene({
          [`${selector} .animationItem`]: i => ({
            ...animation,
            options: {
              delay: i * 0.09,
            },
          }),
        }, {
          easing:   'ease-in-out',
          selector: true,
        });
        this.scene.setDuration(duration);
        if (!onEnter) {
          this.scene.setTime('50%');
        }
      } else {
        this.scene = new Scene({
          [selector]: animation,
        }, {
          easing:   'ease-in-out',
          selector: true,
        });
      }
      this.scene.play();

      const self = this;
      setTimeout(() => {
        self.scene.on('ended', this.sceneEnded);
      }, 50);
    },
    sceneEnded() {
      this.scene.setTime(0);
      if (this.typingSelector) {
        document.querySelector(this.typingSelector).innerHTML = this.originalTextHTML;
        this.typingSelector                                   = '';
      }
      if (this.tempHtml) {
        const elementToReplace = document.querySelector(this.tempSelector);
        // elementToReplace.replaceWith(this.tempHtml);
        elementToReplace.setAttribute('style', this.tempHtml);
        this.tempHtml = null;
      }
      if (this.selectedObject && this.selectedObject.type == 'shape') {
        this.$store.commit('activeProduct/setIsAnimationInProgress', false);
      }
    },
    spanEachCharacter(el) {
      console.log('spanEachCharacter');
      if (el.nodeType == Node.TEXT_NODE) {
        const text = el.textContent;
        let html   = '';
        [...text].forEach((c) => {
          c     = c.replace(/ /g, '\u00a0');
          html += `<span class="animationItem">${c}</span>`;
        });

        const node = document.createElement('span');
        el.parentNode.insertBefore(node, el);
        el.parentNode.removeChild(el);
        node.outerHTML = html;
      } else {
        Array.from(el.childNodes).forEach((child) => {
          this.spanEachCharacter(child);
        });
      }
    },
    stopScene() {
      this.scene.end();
    },
    pageTransitionEnded() {
      this.scene.setTime(0);
    },
    getTransitionTime(objectSpeed, objectDuration) {
      let percentage = 0;
      if (objectSpeed <= 100) {
        percentage = 10;
      }
      if (objectSpeed <= 80) {
        percentage = 19;
      }
      if (objectSpeed <= 60) {
        percentage = 30;
      }
      if (objectSpeed <= 40) {
        percentage = 38;
      }
      if (objectSpeed <= 20) {
        percentage = 47;
      }
      return (objectDuration / 100) * percentage;
    },
    getTypwriterSpeed(speed, duration) {
      let percentage       = 0;
      const objectSpeed    = parseFloat(speed);
      const objectDuration = parseFloat(duration);

      if (objectSpeed <= 100) {
        percentage = 250;
      }
      if (objectSpeed <= 80) {
        percentage = 150;
      }
      if (objectSpeed <= 60) {
        percentage = 70;
      }
      if (objectSpeed <= 40) {
        percentage = 40;
      }
      if (objectSpeed <= 20) {
        percentage = 5;
      }
      return (objectDuration / 100) * percentage;
    },
  },
};

export default ElementAnimationMixin;
